import axios from 'axios';
import { notifySessionExpired } from './sessionExpiry';

const apiClient = axios.create({
  baseURL: '/api', // Use a relative path to ensure same-origin requests
  headers: {
    'Content-Type': 'application/json',
  },
});

// Session or Entra token can no longer be refreshed silently: tell the user to sign in again.
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      notifySessionExpired(error.response.data?.login_url);
    }
    return Promise.reject(error);
  },
);

export default apiClient;
